import React from "react";
import searchJobs from "./searchJobs";
import iconRemove from "./images/icon-remove.svg";
const searchSet = new Set();

const Listings = () => {
	const [jobResults, setJobResults] = React.useState(searchJobs([]));

	const showJobs = (event) => {
		const searchWord = event.target.innerHTML;
		searchSet.add(searchWord);
		setJobResults((prevJobResults) => searchJobs(Array.from(searchSet)));
	};

	const selectedTags = Array.from(searchSet);

	const removeTag = (event) => {
		searchSet.delete(event.target.parentNode.previousElementSibling.innerHTML);
		setJobResults((prevJobResults) => searchJobs(Array.from(searchSet)));
	};

	const clear = () => {
		searchSet.clear();
		setJobResults((prevJobResults) => searchJobs(Array.from(searchSet)));
	};

	const showSelectedTags = selectedTags.map((tag, index) => {
		return (
			<div key={index} className="tags-search">
				<p>{tag}</p>
				<div onClick={removeTag} className="remove-tag-div">
					<img src={iconRemove} alt="Remove tag"></img>
				</div>
			</div>
		);
	});

	const jobs = jobResults.map((job) => {
		let jobTags = [job[1].role, job[1].level, ...job[1].languages, ...job[1].tools];
		let showJobTags = jobTags.map((jobTag, index) => {
			return (
				<p onClick={(event) => [showJobs(event)]} key={index}>
					{jobTag}
				</p>
			);
		});

		return (
			<div key={job[1].id} className={job[1].featured ? "job-listing-container-featured" : "job-listing-container"}>
				<div className="logo-div">
					<img src={job[1].logo} alt={`${job[1].company} Logo`}></img>
				</div>
				<div className="job-listing-info">
					<div className="job-listing-info-toprow">
						<p className="company">{job[1].company}</p>
						{job[1].new && <p className="new">New!</p>}
						{job[1].featured && <p className="featured">Featured</p>}
					</div>
					<h1>{job[1].position}</h1>
					<div className="job-listing-info-bottomrow">
						<p>{job[1].postedAt}</p>
						<p>•</p>
						<p>{job[1].contract}</p>
						<p>•</p>
						<p>{job[1].location}</p>
					</div>
				</div>
				<div className="tags">{showJobTags}</div>
			</div>
		);
	});

	return (
		<div className="results">
			{Array.from(searchSet).length > 0 && (
				<div className="search-filter">
					<div className="show-selected-tags">{showSelectedTags}</div>
					<p onClick={clear} className="clear">
						Clear
					</p>
				</div>
			)}
			{jobs}
		</div>
	);
};

export default Listings;
